const DESIGNER_ASSET_ROOT = '/images/door-designer';

export function resolveCatalogueAssetUrl(assetPath: string | null | undefined): string | null {
  if (!assetPath) return null;
  const trimmed = assetPath.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('/images/')) return trimmed;
  const withSlash = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${DESIGNER_ASSET_ROOT}${withSlash}`;
}
